// EM-N1 (retest 30 Oct 2026): on an environment that sends no email, the
// screens still said "sent" and "Invited", so testers could not tell. Driven
// by the mail configuration (GET /api/meta mailNotDelivered), never by the
// host name. Owners and admins get a link to the outbox.
import { Link } from "react-router";
import { useMeta } from "../api/meta";
import { Notice } from "../ui/Notice";

export function TestMailBanner({ canSeeOutbox }: { canSeeOutbox: boolean }) {
  const meta = useMeta();
  if (!meta.mailNotDelivered) return null;
  return (
    <Notice kind="warning" title="Test environment: emails are not sent">
      <p>
        Where a screen says an email was sent or someone was invited, the email was made but not delivered.
        {canSeeOutbox ? (
          <>
            {" "}
            <Link to="/settings/outbox">See what would have been sent</Link>.
          </>
        ) : null}
      </p>
    </Notice>
  );
}
